export const DemoBox = (props) => (
  <p className={`height-${props.value}`}>{props.children}</p>
)
